import { gql } from '@apollo/client';

const SHIPMENT_PARCELS_QUERY = gql`
  query shipmentParcels {
    shipmentParcels {
      id
      name
      length
      width
      height
      distanceUnit
      weight
      weightUnit
    }
  }
`;

export default SHIPMENT_PARCELS_QUERY;
